const ITEMS = [
  "AI Agentic Systems",
  "n8n Automation",
  "React Full-Stack",
  "Zero-Latency Integrations",
  "LLM Fine-Tuning",
  "Real-Time Dashboards",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-border py-5 select-none"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee gap-10 pr-10">
        {row.map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-10 whitespace-nowrap font-mono text-xs uppercase tracking-[0.25em] text-muted-foreground"
          >
            {item}
            <span className="font-display text-coral text-base leading-none">{"}"}</span>
          </span>
        ))}
      </div>
    </div>
  );
};
